import React, { FC } from "react";

import { Header, HeaderContainer, HeaderFrontView } from "../styled";
import { FeatureCardControls } from "../components/FeatureCardHeader/FeatureCardControls";
import { FeatureCardButtons } from "../components/FeatureCardHeader/FeatureCardButtons";
import { FeatureCardIcon } from "../components/FeatureCardHeader/FeatureCardIcon";
import { FeatureCardTitle } from "../components/FeatureCardHeader/FeatureCardTitle";
import { ContainerProps } from "../types";

export const DefaultHeader: FC<ContainerProps> = ({ renderElement }) => {
  return (
    <>
      <Header $isRow>
        <HeaderFrontView>
          <HeaderContainer>
            <FeatureCardIcon image={renderElement({ id: "image", wrap: false })} />
            <FeatureCardTitle
              title={renderElement({ id: "title", wrap: false })}
              description={renderElement({ id: "description", wrap: false })}
            />
          </HeaderContainer>
          <FeatureCardButtons />
        </HeaderFrontView>
      </Header>
      <FeatureCardControls />
    </>
  );
};
